<div class="grid m-0">
    <div class="xl:mb-4 col-4 xl:col-12 flex align-items-center justify-content-center py-0">
        <div class="text-center">
            <p class="xl:mt-0 font-bold" translate>INFORMATION</p>
            <div class="c100 {{informationColor}} p{{informationNum}} small backgroud-graphic" style="font-size: 100px;">
                <span>{{informationScore}}</span>
                <div class="slice flex align-items-center justify-content-center">
                    <div class="bar"></div>
                    <div class="fill"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="xl:mb-4 col-4 xl:col-12 flex align-items-center justify-content-center py-0">

        <div class="text-center">
            <p class=" font-bold" translate>REPUTATION</p>
            <div class="c100 {{reputationColor}} p{{reputationNum}} small backgroud-graphic" style="font-size: 100px;">
                <span>{{reputationScore}}</span>
                <div class="slice flex align-items-center justify-content-center">
                    <div class="bar"></div>
                    <div class="fill"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="xl:mb-4 col-4 xl:col-12 flex align-items-center justify-content-center py-0">

        <div class="text-center">
            <p class=" font-bold" translate>TRUST</p>
            <div class="c100 {{trustColor}} p{{trustNum}} small backgroud-graphic" style="font-size: 100px;">
                <span>{{trustScore}}</span>
                <div class="slice flex align-items-center justify-content-center">
                    <div class="bar"></div>
                    <div class="fill"></div>
                </div>
            </div>
        </div>
    </div>
</div>